import React from 'react';
import { string } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Button } from '@thd-olt-component-react/button';
import { Image } from '@thd-olt-component-react/core-ui';
import './prop-65.scss';
import classnames from 'classnames';

const WARNING_IMAGE = 'https://assets.thdstatic.com/p/static/images/warning.png';

export const Prop65 = ({ channel, value }) => {
  const isMobile = channel === 'mobile';
  const buttonId = isMobile ? 'prop65__tooltip--mobile' : 'prop65__tooltip';
  const containerClass = classnames('prop65-tooltip__container', {
    'prop65-tooltip__container--padding': isMobile,
  });
  return (
    <div className="prop65-wrapper">
      <div key="prop65-bullet" className="prop65-wrapper--flex">
        <div>California residents</div>
        <Tooltip
          channel={isMobile ? 'mobile' : 'desktop'}
          content={(
            <div className={containerClass}>
              <p className="prop65-tooltip__warning">
                <Image src={WARNING_IMAGE} alt="Warning" width="28" height="22" />
                <span className="u__bold">WARNING!</span>
              </p>
              <div className="prop65-tooltip__content">{value}</div>
            </div>
          )}
          closeButton
          distance={0}
          placement="bottom"
        >
          <div>
            <Button link id={buttonId} className="list__link">see Prop 65 WARNINGS</Button>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

Prop65.displayName = 'Prop65';

Prop65.propTypes = {
  channel: string.isRequired,
  value: string.isRequired
};
